import React from 'react';
import BoArt from './BoArt';
import { APP_STORE_BADGE, APP_STORE_URL } from '../config/site';

// Apple's badge is 119.66407 x 40 (its viewBox). Drawn at the height of the
// large button beside it - above Apple's 40 px minimum.
const BADGE_HEIGHT = 56;
const BADGE_WIDTH = Math.round((BADGE_HEIGHT * 119.66407) / 40);

/**
 * Hero: the promise, the one action (the App Store, Apple's own badge - the
 * page's only one, as Apple asks), and Bo in his Sifu
 * stance. The app itself is the film right under it (HeroFilm, its own
 * section, full width), so the hero stays copy-first and its first paint
 * is instant: text and one small SVG, no entry animation.
 */
const Hero = () => (
  <section className="hero" id="home" aria-labelledby="hero-headline">
    <div className="hero-copy">
      <p className="chip">On iPhone and Apple Watch · iOS 27</p>
      <h1 id="hero-headline" className="h1">
        Train solo.
        <br />
        Get stronger <span className="h1-block">together.</span>
      </h1>
      <p className="lead">
        Get stronger with one kettlebell, a simple plan, and people who show up with you.
      </p>
      <div className="hero-ctas">
        <a href={APP_STORE_URL} rel="noopener" className="app-store-badge">
          <img
            src={APP_STORE_BADGE}
            alt="Download on the App Store"
            width={BADGE_WIDTH}
            height={BADGE_HEIGHT}
          />
        </a>
        <a href="#how" className="btn btn-ghost btn-large">
          How it works
        </a>
      </div>
      <ul className="hero-facts">
        <li>
          <strong>1–2</strong> <span>kettlebells</span>
        </li>
        <li>
          <strong>2–4</strong> <span>sessions a week</span>
        </li>
        <li>
          <strong>≤ 12</strong> <span>people in a crew</span>
        </li>
      </ul>
    </div>

    <div className="hero-visual">
      {/* Bo, beside the promise. Decorative: the words say what matters. */}
      <BoArt pose="sifu" width={360} className="hero-bo" />
    </div>
  </section>
);

export default Hero;
